import { useState } from "react";
import Sidebar from "./Sidebar";
import TopNavbar from "./TopNavbar";
import DataTable from "./DataTable";
import ManagePreference from "./sidebar_tools/ManagePreference";
import ManageTemplate from "./sidebar_tools/ManageTemplate";
import SupportVideos from "./sidebar_tools/SupportVideos";
import KeyboardShortcut from "./sidebar_tools/KeyboardShortcut";
import VoiceSupport from "./sidebar_tools/VoiceSupport";
import { Outlet } from "react-router-dom";

export default function LayoutWithSidebar({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeToolId, setActiveToolId] = useState(null);
  const [showSupportVideos, setShowSupportVideos] = useState(false);
  const [showKeyboardShortcut, setShowKeyboardShortcut] = useState(false);
  const [showVoiceSupport, setShowVoiceSupport] = useState(false);
  const [previousToolId, setPreviousToolId] = useState(null);
  const handleToolSelect = (id) => {
    // Support Videos
    if (id === 5) {
      setPreviousToolId(activeToolId);
      setShowSupportVideos(true);
    }
    // Keyboard Shortcut
    else if (id === 6) {
      setShowKeyboardShortcut(true);
    }
    // Voice Support
    else if (id === 7) {
      setShowVoiceSupport(true);
    }
    // Other tools
    else {
      setActiveToolId(id);
    }
  };
  const handleCloseSupportVideos = () => {
    setShowSupportVideos(false);
    setActiveToolId(previousToolId);
  };
  const handleCloseKeyboardShortcut = () => {
    setShowKeyboardShortcut(false);
  };
  const handleCloseVoiceSupport = () => {
    setShowVoiceSupport(false);
  };
  // Full screen Support Videos
  if (showSupportVideos) {
    return <SupportVideos onClose={handleCloseSupportVideos} />;
  }
  return (
    <div className="layout">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onOpen={() => setSidebarOpen(true)}
        activeToolId={activeToolId}
        onToolSelect={handleToolSelect}
      />
      <div className="main">
  <TopNavbar
    onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
  />

  <div
    style={{
      flex: 1,
      overflow: "auto",
      backgroundColor: "#f5f7fa",
    }}
  >
    <Outlet />
  </div>
</div>
      {/* Keyboard Shortcut Modal */}
      {showKeyboardShortcut && (
        <KeyboardShortcut
          onClose={handleCloseKeyboardShortcut}
        />
      )}
      {/* Voice Support Modal */}
      {showVoiceSupport && (
        <VoiceSupport
          onClose={handleCloseVoiceSupport}
        />
      )}
    </div>
  );
}